import { render, staticRenderFns } from "./EscalaModeloPadrao.vue?vue&type=template&id=d6bf3d88&"
import script from "./EscalaModeloPadrao.vue?vue&type=script&lang=js&"
export * from "./EscalaModeloPadrao.vue?vue&type=script&lang=js&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&"
import style1 from "./EscalaModeloPadrao.vue?vue&type=style&index=1&id=d6bf3d88&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports